export default "__VITE_ASSET__DqCrBJRB__"